import { Control } from "rete";
import SwitchComponent from "./switch-component";

export class SwitchControl extends Control {
  constructor(emitter, key, type, readonly, state) {
    super(key);
    this.component = SwitchComponent;
    this.props = {
      emitter,
      ikey: key,
      type,
      readonly,
      state
    };
  }

  setValue(value) {
    this.vueContext.value = value;
  }
}
